import { api } from '../AppConfig';
import * as Settings from '../utils/AuthUtils';
import { connect, catch401s, getToken, setUserSession } from './utils';
//import { getToken, setUserSession } from '../utils/common';

const ajaxMe = connect(() => ({
  me: {
    url: api.me().href,
    headers: {
      Authorization: 'Bearer ' + Settings.getToken(),
    },
    force: true,
    catch: catch401s,
  },
  login: (resolve,reject, uc) => ({
    loginData: {
      url: api.meLogin(uc).href,
      method: 'POST',
      body: JSON.stringify({ ...uc }),
      andThen: response => {
        return {
          me: {
            url: api.me().href,
            headers: {
              Authorization: 'Bearer ' + Settings.getToken(),
            },
            then: resolve,
            catch: reject,
            force: true,
            refreshing: true,
          },
      }},
      catch: reject,
      force: true,
    }
  }),
}));

export default ajaxMe;